import React from "react";
import classnames from "classnames";
import Image from "basic-elements/Image";
import PageLink from "basic-elements/PageLink";
import Container from "public-components/Container";
import { Store } from "public-components/StoreProvider";
import IconClose from "./close.svg";
import IconPlay from "./play.svg";
import styles from "./HeroSection.module.scss";

import HeroRoundBG from "./hero-round.svg";

const HeroSection = ({ data }) => {
  const { dispatch } = React.useContext(Store);
  const [heroBox] = React.useState(React.createRef());
  const [showModal, setShowModal] = React.useState(false);

  const animations = React.useRef(data.galleryImage.map(i => i.id));
  const [currentAnimation, setCurrentAnimation] = React.useState("");

  React.useEffect(() => {
    const handlePageScroll = () => {
      dispatch({
        type: "TOGGLE_HEADER_STYLE",
        payload: window.pageYOffset >= heroBox.current.offsetHeight - 200
      });
    };
    handlePageScroll();

    window.addEventListener("scroll", handlePageScroll);

    return () => {
      window.removeEventListener("scroll", handlePageScroll);
    };
  }, [heroBox, dispatch]);

  const handleModalBodyClick = e => {
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      setShowModal(false);
    }
  };

  React.useEffect(() => {
    setCurrentAnimation(animations.current[0]);
  }, [animations]);

  React.useEffect(() => {
    const animationTimer = setInterval(() => {
      let targetIdx = animations.current.indexOf(currentAnimation) + 1;
      targetIdx = targetIdx >= animations.current.length ? 0 : targetIdx;
      setCurrentAnimation(animations.current[targetIdx]);
    }, 5000);

    return () => {
      clearInterval(animationTimer);
    };
  }, [currentAnimation]);

  const handleVideoHover = id => {
    const $target = document.getElementById(`video-${id}`);
    const $targetIcon = document.getElementById(`video-icon-${id}`);
    if ($target) $target.play();
    if ($targetIcon) $targetIcon.style.opacity = "0";
  };

  const handleVideoLeave = id => {
    const $target = document.getElementById(`video-${id}`);
    const $targetIcon = document.getElementById(`video-icon-${id}`);
    if ($target) $target.pause();
    if ($targetIcon) $targetIcon.style.opacity = "1";
  };

  return (
    <div className={styles.hero} ref={heroBox}>
      <HeroRoundBG className={styles.hero__round} />
      <Container>
        <div className={styles.hero__row}>
          <div className={styles.hero__left}>
            <h1 className={styles.hero__heading}>{data.headingH1}</h1>
            <div
              className={styles.hero__subheading}
              dangerouslySetInnerHTML={{ __html: data.text }}
            />
            <button className={styles.hero__button} onClick={() => setShowModal(true)}>
              {data.buttonText}
            </button>
          </div>
          <div className={styles.hero__right}>
            {data.galleryImage.map(i => (
              <div key={i.id} className={styles.hero__imageWrap}>
                <Image
                  className={classnames(
                    styles.hero__image,
                    currentAnimation === i.id ? styles.active : null
                  )}
                  data={i}
                />
              </div>
            ))}
            <ol className={styles.indicator}>
              {data.galleryImage.map(i => (
                <li
                  key={i.id}
                  className={classnames(
                    styles.indicator__item,
                    currentAnimation === i.id ? styles.active : null
                  )}
                  onClick={() => setCurrentAnimation(i.id)}
                >
                  <span className={styles.indicator__bar} />
                </li>
              ))}
            </ol>
          </div>
        </div>
      </Container>
      {showModal && (
        <div className={styles.heroModal} onClick={handleModalBodyClick}>
          <div className={styles.heroModal__box}>
            <div className={styles.heroModal__close} onClick={() => setShowModal(false)}>
              <IconClose />
            </div>
            <h2 className={styles.heroModal__heading}>{data.modalTitle}</h2>
            <ul className={styles.heroModal__list}>
              {data.children.map(i => (
                <li key={i.id} className={styles.appEntry}>
                  <div className={styles.appEntry__videoWrapper}>
                    <IconPlay
                      id={`video-icon-${i.appType}`}
                      className={styles.appEntry__videoWrapperIcon}
                    />
                    <video
                      muted
                      loop
                      preload="true"
                      poster={`${process.env.ASSET_PREFIX || ""}/videos/${i.appType}/${
                        i.appType
                      }.jpg`}
                      className={styles.appEntry__video}
                      id={`video-${i.appType}`}
                      onMouseEnter={() => handleVideoHover(i.appType)}
                      onMouseLeave={() => handleVideoLeave(i.appType)}
                    >
                      <source
                        src={`${process.env.ASSET_PREFIX || ""}/videos/${i.appType}/${
                          i.appType
                        }.mp4`}
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <div
                    className={styles.appEntry__text}
                    dangerouslySetInnerHTML={{ __html: i.text }}
                  />
                  <PageLink className={styles.appEntry__button} data={i.pageLink} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroSection;
